export default __webpack_public_path__ + "static/media/Thumb_Glasses_05.472daca2.png";